// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/tail-configurations.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/tail-configurations/tail-configurations.js';

mount([g0]);
